import { FC } from 'react';
import HtmlToReact from 'html-to-react';

import { IHtmlContentProps } from './HtmlContent.interface';

const htmlToReactParser = new HtmlToReact.Parser();

const formatLink = (link: string): string => {
  if (link.startsWith('/') || link.startsWith('http') || link.startsWith('mailto:')) {
    return link;
  }
  return `https://${link}`;
};
const HtmlContent: FC<IHtmlContentProps> = ({ children, className }) => {
  const formattedHTML = (htmlString: string): string => {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    const links = doc.querySelectorAll('a');

    links.forEach(link => {
      const href = link.getAttribute('href');
      if (href) {
        link.setAttribute('href', formatLink(href));
      }
    });

    return doc.documentElement.outerHTML;
  };

  const processedHTML = formattedHTML(children || '');
  return <div className={className}>{htmlToReactParser.parse(processedHTML)}</div>;
};

export default HtmlContent;
